import { render, staticRenderFns } from "./mortgageEdit.vue?vue&type=template&id=381dc47c&scoped=true&lang=html&"
import script from "./mortgageEdit.vue?vue&type=script&lang=js&"
export * from "./mortgageEdit.vue?vue&type=script&lang=js&"
import style0 from "./mortgageEdit.vue?vue&type=style&index=0&id=381dc47c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381dc47c",
  null
  
)

export default component.exports